<template>
  <div class="jump">
    <!-- <p style="24px">
      正在跳转到支付页面，请稍候~
    </p> -->
    <img src="@/assets/images/loading.gif" alt="" />
  </div>
</template>

<script>
import {getRedirectUrl, getPayOrderInfo} from '@/api/api';
import config from '@/config';
import channelUserIdUtil from '@/utils/channelUserId';

// 分发器页面，  用户扫码后进入的第一个页面：
// 判断是否存在channelUserId, 如果存在则直接跳到 对应的支付页面，如果不存在则重定向到对应的页面。
export default {
  components: {
  },

  mounted() {

    console.log("正在跳转", this.$route.params)

    // 获取token参数
    const token = this.$route.params.jToken || this.$route.query.jToken;
    if (!token) {
      this.$router.push({ name: config.errorPageRouteName, params: { errInfo: '缺少必要参数' } })
      return;
    }

    // 设置全局token
    config.cacheToken = token;

    // 获取支付订单信息，根据wayCode判断跳转到哪个页面
    getPayOrderInfo().then(res => {
      let wayCode = res.wayCode;
      console.log('原始wayCode:', wayCode)
      
      // 如果是QR_CASHIER，根据User-Agent判断实际支付方式
      if (wayCode === 'QR_CASHIER') {
        const userAgent = navigator.userAgent;
        if (userAgent.indexOf('MicroMessenger') >= 0) {
          wayCode = 'WX_JSAPI';
        } else if (userAgent.indexOf('AlipayClient') >= 0) {
          wayCode = 'ALI_JSAPI';
        }  else {
          // 普通浏览器，直接跳转到二维码页面
          console.log('普通浏览器，跳转到二维码页面');
          this.$router.push({ name: 'CashierQrCashier', params: { jToken: token } });
          return;
        }
        console.log('QR_CASHIER转换为:', wayCode)
      }
      
      // WX_JSAPI 和 ALI_JSAPI 需要先获取 channelUserId（微信openId/支付宝userId）
      if (wayCode === 'WX_JSAPI' || wayCode === 'ALI_JSAPI') {
        console.log('[调试] 开始检查channelUserId');
        // 检查是否已有 channelUserId
        let channelUserId = null;
        try {
          channelUserId = channelUserIdUtil.getChannelUserId();
          console.log('[调试] 获取到channelUserId:', channelUserId);
        } catch (e) {
          console.error('[调试] 获取channelUserId失败:', e);
        }
        console.log('当前wayCode:', wayCode, 'channelUserId:', channelUserId);
        if (!channelUserId) {
          // 没有 channelUserId，需要跳转到 OAuth2 授权页面获取
          console.log('没有channelUserId，跳转到OAuth2授权');
          console.log('调用getRedirectUrl，当前token:', config.cacheToken);
          getRedirectUrl().then(redirectRes => {
            // redirectRes 是微信/支付宝的 OAuth2 授权地址
            console.log('OAuth2跳转地址:', redirectRes);
            console.log('redirectRes类型:', typeof redirectRes);
            console.log('redirectRes内容:', JSON.stringify(redirectRes));
            
            // 检查是否为有效URL
            if (typeof redirectRes === 'string' && redirectRes.startsWith('http')) {
              console.log('即将跳转到:', redirectRes);
              window.location.href = redirectRes;
            } else {
              console.error('返回的不是有效URL:', redirectRes);
              this.$router.push({ name: config.errorPageRouteName, params: { errInfo: 'OAuth2授权地址格式错误' } });
            }
          }).catch(err => {
            console.error('getRedirectUrl失败:', err);
            console.error('错误详情:', JSON.stringify(err));
            this.$router.push({ name: config.errorPageRouteName, params: { errInfo: err.msg || err.message || '获取授权地址失败' } });
          });
          return;
        }
        console.log('已有channelUserId:', channelUserId);
      }
      
      // 根据wayCode跳转到对应的支付页面
      if (wayCode === 'WX_JSAPI' || wayCode === 'QR_CASHIER') {
        this.$router.push({ name: 'CashierWxpay', params: { jToken: token } });
      } else if (wayCode === 'ALI_JSAPI') {
        this.$router.push({ name: 'CashierAlipay', params: { jToken: token } });
      } else if (wayCode === 'BANK_MANUAL') {
        this.$router.push({ name: 'CashierFdrManual', params: { jToken: token } });
      } else if (wayCode === 'ALIPAY_MANUAL') {
        this.$router.push({ name: 'CashierFdrQrCode', params: { jToken: token } });
      } else if (wayCode === 'LIANLIAN_CASHIER') {
        this.$router.push({ name: 'CashierQuickpay', params: { jToken: token } });
      } else {
        this.$router.push({ name: config.errorPageRouteName, params: { errInfo: '不支持的支付方式' } });
      }
    }).catch(err => {
      this.$router.push({ name: config.errorPageRouteName, params: { errInfo: err.msg } })
    })

  }


}
</script>
<style lang="css" scoped>
  .jump {
    height:100vh;
    width: 100vw;
    display:flex;
    justify-content: center;
    align-items: center;
  }
</style>
